<template>
  <svg
    width="20"
    height="22"
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="large-lock-title"
  >
    <path
      d="M11 16.0049C11.5978 15.6742 12 15.0559 12 14.3478C12 13.2913 11.1046 12.4348 10 12.4348C8.89543 12.4348 8 13.2913 8 14.3478C8 15.0559 8.4022 15.6742 9 16.0049V17.6957C9 18.2239 9.44771 18.6522 10 18.6522C10.5523 18.6522 11 18.2239 11 17.6957V16.0049Z"
      fill="#8A8A8F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.33333 8.6087H3.00019C3.02419 3.02337 5.36597 0 10 0C14.6345 0 16.9763 3.0234 16.9998 8.6087H18.6667C19.403 8.6087 20 9.17969 20 9.88406V20.7246C20 21.429 19.403 22 18.6667 22H1.33333C0.596954 22 0 21.429 0 20.7246V9.88406C0 9.17969 0.596954 8.6087 1.33333 8.6087ZM14.9998 8.6087H5.00018C5.02018 3.87561 6.6783 1.73913 10 1.73913C13.3222 1.73913 14.9802 3.87557 14.9998 8.6087ZM2 10.5217V20.087H18V10.5217H2Z"
      fill="#8A8A8F"
    />
    <title id="large-lock-title">{{ title }}</title>
  </svg>
</template>

<script lang="ts">
export default {
  name: 'LargePrivacyLock',
  props: {
    title: {
      type: String,
      default: 'is locked',
    },
  },
};
</script>
